import { ADD_MEMBERS, InviteAgencyUserService, toastr, REDIRECT, UNPROCESSABLE_ENTITY_RESPONSE_CODE, SUCCESS_REPONSE_CODE, 
    handleOtherResponseCode, CustomToastrAction, PageStyle, Button, ButtonStyle, cursorNone, getAgencyOrClientUsers } from "@/imports-files/pages/clients/company/invite-agency-users";
export class InviteAgencyUsersAction
{

constructor(setLoader)
{
this.InviteAgencyUserService   =  new InviteAgencyUserService();
this.setLoader           =  setLoader;
this.customToastrAction  =  new CustomToastrAction(); 

}


async addTeamMembers(params, router)
{     
    // this.setLoader(true);
    // const body        = { agency: {id: params.agency.id, agency_users_attributes: params.agency.agency_users_attributes}} 
    // const result      = await this.InviteAgencyUserService.addMembers(body);
    // const status_code = result.status || result.response.status;

    // switch (status_code)
    // {  
    //     case SUCCESS_REPONSE_CODE:
    //     this.setLoader(false);
    //     this.customToastrAction.setNormalToastr(result.data.success, 'success');
    //     router.push(REDIRECT.agency.company.add_team);
    //     break;
    //     case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    //     this.setLoader(false);
    //     let error = result.response.data.error.agency.base
    //     this.customToastrAction.setNormalToastr(error, 'warning');
    //     return result.response.data.error
    //     break;
    //     default: 
    //     this.setLoader(false);
    //     handleOtherResponseCode(status_code, args.router);
    // }
}

async onAdminUserRemove(...args) 
{
// ---------------------------- Initialization ------------------------------
const formik                    =   args[0];
const action                    =   args[1];
const setAdminCount             =   args[2];
const index                     =   args[3]!=undefined ? args[3] : '';
const queryClient               =   args[4];
const loader                    =   args[5];
const agency_users_attributes   =   formik.values.agency.agency_users_attributes;
const agency                    =   formik.values.agency
// ---------------------------- Initialization ------------------------------

agency_users_attributes[index]['_destroy'] = true;

// formik.current.setValues({agency, agency_users_attributes});
formik.setValues({agency, agency_users_attributes});
var records_length = agency_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
await queryClient.setQueryData('add-user-data', agency_users_attributes);
setAdminCount(records_length);
}

async onAdminUserAdd(...args) 
{
// ---------------------------- Initialization ------------------------------
const formik                    =   args[0]?.current;
const action                    =   args[1];
const setAdminCount             =   args[2];
const queryClient               =   args[3];
const agency_users_attributes   =   formik.values.agency.agency_users_attributes;
const agency                    =   formik.values.agency
// ---------------------------- Initialization ------------------------------

 agency_users_attributes.push({
                                 role_id: "",
                                 status_id: "",
                                 _destroy: false,
                                 user_attributes:{
                                                   name: '',
                                                   email: ''
                                                 }
                             })

// formik.current.setValues({agency, agency_users_attributes});
formik.setValues({agency, agency_users_attributes});
var records_length = agency_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
await queryClient.setQueryData('add-user-data', agency_users_attributes);
setAdminCount(records_length);
}

async onAdminUserAdd(...args) 
{
// ---------------------------- Initialization ------------------------------
const formik                    =   args[0]?.current;
const action                    =   args[1];
const setAdminCount             =   args[2];
const queryClient               =   args[3];
const agency_users_attributes   =   formik.values.agency.agency_users_attributes;
const agency                    =   formik.values.agency
// ---------------------------- Initialization ------------------------------

 agency_users_attributes.push({
                                 role_id: "",
                                 status_id: "",
                                 _destroy: false,
                                 user_attributes:{
                                                   name: '',
                                                   email: ''
                                                 }
                             })

// formik.current.setValues({agency, agency_users_attributes});
formik.setValues({agency, agency_users_attributes});
var records_length = agency_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
await queryClient.setQueryData('add-user-data', agency_users_attributes);
setAdminCount(records_length);
}

async onAdminUserRemove(...args) 
{
// ---------------------------- Initialization ------------------------------
const formik                    =   args[0];
const action                    =   args[1];
const setAdminCount             =   args[2];
const index                     =   args[3]!=undefined ? args[3] : '';
const queryClient               =   args[4];
const agency_users_attributes   =   formik.values.agency.agency_users_attributes;
const agency                    =   formik.values.agency
// ---------------------------- Initialization ------------------------------

agency_users_attributes[index]['_destroy'] = true;

// formik.current.setValues({agency, agency_users_attributes});
formik.setValues({agency, agency_users_attributes});
var records_length = agency_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
await queryClient.setQueryData('add-user-data', agency_users_attributes);
setAdminCount(records_length);
}

async handelFileChange(data, formik, userRoles, fileInfo)
{
this.setLoader(true);
var fileSize = this.fileSizeValid(fileInfo);
var csvValid = this.isCSVFileValid(data, userRoles);
if(!(fileSize && csvValid) )
{
 this.setLoader(false);
 return false;
}
else
{
 // TODO : - set the errors in the formik schema
     const agency_users_attributes = formik.current.values.agency.agency_users_attributes;
     const agency                  = formik.current.values.agency
 // ---------------------------- Initialization ------------------------------

 data.length > 0 ? this.remove_blank_formik_fields(formik, agency, agency_users_attributes) : '';

 for( var user of data)
 {
   var role_id = userRoles.findIndex(obj => obj.label === user.role)
   agency_users_attributes.push({
                                   role_id: userRoles[role_id].value,
                                   _destroy: false,
                                   user_attributes:{
                                                     name: user.name,
                                                     email: user.email
                                                   }
                               })
 }

 
 document.getElementById('react-csv-reader-input').value = null;
 formik.current.setValues({agency: {agency_users_attributes}});
 formik.current.setTouched({agency: {agency_users_attributes}});
 this.setLoader(false);     
}
}

fileSizeValid(fileInfo)
{
 if(fileInfo.size > ADD_MEMBERS.CSV_FILE_SIZE_LIMIT)
 {
   this.customToastrAction.setNormalToastr('The file size is greater than 1MB', 'success');
   // toastr.success('The file size is greater than 1MB');
   document.getElementById('react-csv-reader-input').value = null
   return false;
 }
 else
 {
   return true;
 }
}

isCSVFileValid(data, userRoles)
{
try
{
 for( var user of data)
 { 
   var role_id = userRoles.findIndex(obj => obj.label === user.role)
   userRoles[role_id].value;
   user.name;
   user.email;
 }

 return true;
}
catch(exception)
{
   this.customToastrAction.setNormalToastr('Invalid File', 'success');
   // toastr.success('Invalid File');
   document.getElementById('react-csv-reader-input').value = null;
   return false;
}
}

remove_blank_formik_fields(formik, agency, agency_users_attributes)
{

for (var index = agency_users_attributes.length-1 ; index >= 0; index--)
{
   if( agency_users_attributes[index].role_id == "" &&
       agency_users_attributes[index].user_attributes.name =="" &&
       agency_users_attributes[index].user_attributes.email =="" )
   {
       agency_users_attributes.splice(index, 1);
   }
   else
   {
     break;
   }
}

formik.current.setValues({agency, agency_users_attributes});

}


}

export function shouldRenderSuggestions(value){
  return value.trim().length >= 3
}
export const renderInputComponent = inputProps => (
  // <input className = {PageStyle.Form__Input} autoComplete="password"
  // {...inputProps} />
  <div className="buttonIn">
    <input className = {PageStyle.Form__Input} autoComplete={"password"}
    {...inputProps} />
    <Button buttonstyle={`${ButtonStyle.nobgbutton} addbtn ${cursorNone(inputProps.editable)}`} disabled={inputProps.disabled} onClick={() => onAddClick(event, inputProps)}>Add</Button>
    {/* <Button buttonstyle={`${ButtonStyle.nobgbutton} addbtn ${cursorNone(editable)}`} disabled={ inputProps.editable != undefined ? inputProps.editable : false} onClick={() => onAddClick(event, inputProps)}>Add</Button> */}
  </div>
);

export function getUserSuggestionValue(suggestion) 
{
  return `${suggestion.user_attributes.email}`;
}

function showSuggestion(suggestion){
  if(suggestion.user_attributes.name && (suggestion.user_attributes.email.length > 0)){
    return `${suggestion.user_attributes.name} | ${suggestion.user_attributes.email}`
  }
  else if(suggestion.user_attributes.name){
    return `${suggestion.user_attributes.name}`
  }
  else{
    return `${suggestion.user_attributes.email}`
  }
}
  
  export function renderUserSuggestion(suggestion) {
    return (
      <span>{showSuggestion(suggestion)}</span>
    );
  }

  function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async function getUserSuggestions(value, router, domain) {
    const escapedValue = escapeRegexCharacters(value?.trim());
    
    if (escapedValue === '') {
    return [];
    }
    let finalUsers = await getAgencyOrClientUsers(escapedValue, router, domain)
    return finalUsers
  }
  
  export async function onUserSuggestionsFetchRequested(hash, setUsers, router, domain){    
    let users = await getUserSuggestions(hash.value, router, domain)
    setUsers(users)
  };
  
  export const onUserSuggestionsClearRequested = (setUsers) => {
    setUsers([])
  };
  
  export function isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  export function onUserSuggestionSelection(formik, old_emails, email, old_initials, new_initial){
    if(isEmail(email) && !old_emails.includes(email))
    {
      if(formik.status?.agency_user_emails){
        formik.setStatus({agency_user_emails: ''})
      }
      old_emails.unshift(email)
      old_initials.unshift(new_initial) 
      formik.validateForm();
    }
  }

  export function handleKeyDown(evt, formik, setAgencyUserEmail, setAgencyUserError, agency_domain){
    if (["Enter"].includes(evt.key)) {
      evt.preventDefault();
      let email = evt.target.value
      if(isEmail(email))
      {
        // if(checkEmailDomain(email, agency_domain)){
          onUserSuggestionSelection(formik, formik.values.agency_user_emails, email, formik.values.agency_user_initials, {email: email, name_initials: null, name: null})
          setAgencyUserEmail('')
        // }
        // else
        // {
        //   formik.setStatus({agency_user_emails: 'User domain should match with agency domain'})
        //   formik.touched['agency_user_emails'] = true;
        // }
      }
      else
      {   
        formik.setStatus({agency_user_emails: ''})                   
        setAgencyUserError("Invalid Email");
      }
    };
  }

  const onAddClick = (event, params) => {
    let email = params.value 
    if(isEmail(email))
    {
      // if(checkEmailDomain(email, params.agency_domain)){
        onUserSuggestionSelection(params.formik, params.formik.values.agency_user_emails, email, params.formik.values.agency_user_initials, {email: email, name_initials: null, name: null})
        params.setAgencyUserEmail('')
      // }
      // else{
      //   params.formik.setStatus({agency_user_emails: 'User domain should match with agency domain'})
      //   params.formik.touched['agency_user_emails'] = true;
      // }
    }
    else
    {  
      params.formik.setStatus({agency_user_emails: ''})       
      params.setAgencyUserError("Invalid Email");
    }
  }

  export function checkEmailDomain(email, agency_domain){
    let user_email_domain  = email?.split("@")[1];
    var user_domain = user_email_domain?.split(".")[0];
    return user_domain == agency_domain
  }


  export function handleEmailDelete(formik, itemIndex )
  {
    let emails = formik.values.agency_user_emails 
    let name_initials = formik.values.agency_user_initials
    emails.splice(itemIndex, 1)
    name_initials.splice(itemIndex, 1)
    formik.setFieldValue(`agency_user_emails`, [...emails])
    formik.setFieldValue(`agency_user_initials`, [...name_initials])
  }

  export async function inviteUsers(values, inviteUserModal,  setInviteUserModal, router, setAgencyUserList){
    const result      = await  new InviteAgencyUserService().inviteUsers(values, inviteUserModal.agency_id);
    const status_code = result.status || result.response.status;
    const customToastrAction  =  new CustomToastrAction(); 
    switch (status_code)
    {  
        case SUCCESS_REPONSE_CODE:
        // this.setLoader(false);
        if(result.data.msg){
          customToastrAction.setNormalToastr(result.data.msg, 'warning');
        }
        else{
          customToastrAction.setNormalToastr(result.data.success, 'success');
        }

        if(setAgencyUserList) setAgencyUserList(result.data)
        setInviteUserModal({state: false})
        break;
        case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        // this.setLoader(false);
        let error = result.response.data.error
        customToastrAction.setNormalToastr(error, 'warning');
        break;
        default: 
        // this.setLoader(false);
        handleOtherResponseCode(status_code, router);
    }
  }
